(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var hero = document.querySelector('[data-password-hero]');
    if (hero) {
      // Trigger entrance transition shortly after paint.
      window.requestAnimationFrame(function () {
        setTimeout(function () {
          hero.classList.add('password-hero--ready');
        }, 60);
      });
    }

    initPasswordModal();
    initParallax();
  });

  function initPasswordModal() {
    var modal = document.querySelector('[data-password-modal]');
    var openers = document.querySelectorAll('[data-password-modal-open]');
    var closers = document.querySelectorAll('[data-password-modal-close]');

    if (!modal || openers.length === 0) return;

    var lastFocused = null;

    function openModal() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      var input = modal.querySelector('input[type="password"]');
      if (input) input.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeModal() {
      modal.hidden = true;
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape') closeModal();
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });
    closers.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
  }

  function initParallax() {
    var media = document.querySelector('[data-parallax] .password-hero__image');
    if (!media) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    var ticking = false;

    function update() {
      var scrollY = window.scrollY || window.pageYOffset;
      var offset = Math.min(scrollY * 0.12, 40);
      media.style.transform = 'translateY(' + offset + 'px) scale(1.06)';
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    media.style.transform = 'scale(1.06)';
  }
})();
